import Download from "../../../components/Files/download";
import { ReactComponent as FiMail } from "../../../layout/other_icons/mail.svg";
import { ReactComponent as FiPhone } from "../../../layout/other_icons/phoneCall.svg";
import { useTranslation } from "react-i18next";
import { PreCandidateService } from "../../../services/PreCandidate";
import DownloadStatusSpinner from "../../../components/DownloadStatusSpinner/DownloadStatusSpinner";
import moment from "moment";
import "./stylesDelete.scss";
import { useState } from "react";
import { toast } from "react-toastify";
import { ApplicationDetailsList } from "../../Interview/ReApplications/InterviewDetailsList";
import { toDateString } from "../../../common/helper";
import i18next from "i18next";
import { DOCOnlineService } from "../../../services/DOCOnlineService";
import { useGeneralContext } from "../../General/Context";
import IconExport from "../../../layout/others/icon_export.svg";
import FileService from "../../../services/FileService";

const ViewDeletePreCandidate = (props) => {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const [htmlDocUrl, setHtmlDocUrl] = useState();
  const [viewDocOnlineStatus, setViewDocOnlineStatus] = useState({
    statusName: "done",
    errorCaught: false
  });

  const GetDocOnlineTemplate = (preCandidateId, format) => {
    setViewDocOnlineStatus({
      statusName: "downloading",
      errorCaught: false
    });

    PreCandidateService.GetDocOnlineTemplate(
      preCandidateId,
      getDownloadDocOnlineFileName(format),
      format
    )
      .then(() => {
        setViewDocOnlineStatus({
          errorCaught: false,
          statusName: "downloaded"
        });
      })
      .catch((err) => {
        setViewDocOnlineStatus((prevState) => ({
          ...prevState,
          errorCaught: true
        }));
        console.error(err);
        toast.error(t("Something went wrong."));
      })
      .finally(() =>
        setTimeout(
          () =>
            setViewDocOnlineStatus((prevState) => ({
              ...prevState,
              statusName: "done"
            })),
          3000
        )
      );
  };

  const getDownloadDocOnlineFileName = (format) => {
    return (
      "DOCOnline_" +
      props.precandidate.fullName.replace(" ", "") +
      "_" +
      moment().unix() +
      "." +
      format
    );
  };
  function generateUrl() {
    if (htmlDocUrl) window.open(htmlDocUrl);
    else
      DOCOnlineService.generateUrl(
        i18next.language,
        userInformation.companyId,
        props.precandidate?.documentId
      ).then((data) => {
        setHtmlDocUrl(data.url);
        setTimeout(() => window.open(data.url), 2000);
      });
  }

  const handleConvertToDocOnline = (documentId) => {
    const formData = {
      precandidateId: props.precandidate.id,
      fileId: documentId
    };
    FileService.convertToDocOnline(formData).then(() => {
      refreshDocuments();
      toast.success(t("DocOnline successfully created"));
    });
  };

  function refreshDocuments() {
    props.setUpdatePreCandidateList(!props.updatePreCandidateList);
  }

  return (
    <>
      <div>
        <h4 className="fw-bold">{props.precandidate.formerCompany}</h4>
        <div className="attribute">
          <strong>{t("Curriculum")}</strong>
          {props.precandidate?.files?.length > 0 ? (
            <div className="row align-items-center">
              {props.precandidate?.files &&
                props.precandidate?.files.map((file) => (
                  <div
                    className="col-4 text-truncate"
                    key={file.id}
                    title={file.filename}
                    style={{display: "flex", width: "480px"}}
                  >
                    <Download
                      url={`vitae/file/${file.id}`}
                      fileName={file.filename}
                    />
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleConvertToDocOnline(props.precandidate.documentId);
                      }}
                      className="action-button"
                      title={t("Convert to DocOnline")}
                      style={{ marginLeft: "20px" }}
                    >
                      <img
                        src={IconExport}
                        alt="convert to doconline"
                        width="18px"
                        height="22px"
                        marginTop="-4px"
                      />
                    </button>
                  </div>
                ))}
            </div>
          ) : (
            <div className="info">
              <p>{t("No curriculum was uploaded to this pre-candidate.")}</p>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md">
            <div className="attribute">
              <strong>{t("Doc Online")}</strong>
              <div className="info">
                {props.precandidate?.docOnlineExists ? (
                  <>
                    <div className="cv-wrapper mt-2">
                      {props.precandidate?.pdfDoc && (
                        <button
                          className="action-button"
                          onClick={() =>
                            GetDocOnlineTemplate(props.precandidate?.id, "pdf")
                          }
                        >
                          <i class="bi bi-filetype-pdf"></i>
                        </button>
                      )}
                      {props.precandidate?.wordDoc && (
                        <button
                          className="action-button"
                          onClick={() =>
                            GetDocOnlineTemplate(props.precandidate?.id, "docx")
                          }
                        >
                          <i class="bi bi-file-earmark-word"></i>
                        </button>
                      )}
                      {props.precandidate?.htmlDoc && (
                        <button
                          className="action-button"
                          onClick={() => generateUrl()}
                        >
                          <i class="bi bi-filetype-html"></i>
                        </button>
                      )}

                      <DownloadStatusSpinner
                        textPending={t("Loading...")}
                        textDone={t("Done!")}
                        downloadStatus={viewDocOnlineStatus.statusName}
                        errorCaught={viewDocOnlineStatus.errorCaught}
                      />
                    </div>
                  </>
                ) : (
                  <div className="info">
                    <p>
                      {t(
                        "There is not submitted Doc Online for this pre-candidate."
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="attribute">
              <strong>{t("Full Name")}</strong>
              <div className="info">
                <p>{props.precandidate?.fullName}</p>
              </div>
            </div>
          </div>
          <div className="col-md-3" width="31%">
            <div className="attribute">
              <strong>{t("Email Address")}</strong>
              <div className="info">
                <div className="ico">
                  <FiMail
                    width="18px"
                    height="18px"
                    className="color-mail-icon"
                  />
                </div>
                <p>{props.precandidate?.emailAddress}</p>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="attribute">
              <strong>{t("Mobile number")}</strong>
              <div className="info">
                <div className="ico">
                  <FiPhone width="18px" height="18px" />
                </div>
                <a href={`tel:${props.precandidate?.phoneNumber}`}>
                  {props.precandidate?.phoneNumber}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="attribute">
              <strong>{t("Business Area")}</strong>
              <div className="info">
                <p>
                  {props.precandidate?.businessAreas
                    ?.map((x) => x.description)
                    .join(",")}
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3" style={{ marginLeft: "93px" }}>
            <div className="attribute">
              <strong>{t("Technical Area")}</strong>
              <div className="info">
                <p>{props.precandidate.techAreaDescription}</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="attribute">
              <strong>{t("Technical Role")}</strong>
              <div className="info">
                <p>
                  {props.precandidate.techRoleDescription !== null
                    ? props.precandidate.techRoleDescription
                    : props.precandidate.jobRoleDescription}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="attribute">
              <strong>{t("Availability")}</strong>
              <div className="info">
                <p>
                  {t(props.precandidate?.availabilityStatus)}{" "}
                  {toDateString(props.precandidate?.nextContact)}{" "}
                  {t(props.precandidate?.availabilityReason)}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div>
            <strong>{t("Application Details")}</strong>
          </div>
          <ApplicationDetailsList
            list={props.precandidate.applicationDetails}
            viewMode={true}
            activeId={
              props.precandidate?.applicationDetails
                ? props.precandidate.applicationDetails[0].id
                : 0
            }
          />
        </div>
      </div>
    </>
  );
};

export default ViewDeletePreCandidate;
